import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { DisplayNotificationService } from 'src/app/shared/services/common/notification.service';
import { UsersService } from 'src/app/shared/services/common/users.service';
import { ReadConfigService } from 'src/app/shared/services/common/read-config.service';

@Component({
  selector: 'app-view-org-info',
  templateUrl: './view-org-info.component.html',
  styleUrls: ['./view-org-info.component.css']
})
export class ViewOrgInfoComponent implements OnInit {
  orgInformation: any;
  paymentType: any;

  constructor(
    private userService: UsersService,
    private readConfigService: ReadConfigService,
    private notificationService: DisplayNotificationService) { }

  ngOnInit() {
    this.notificationService.setUpLoading(true);
    this.getOrganizationInfo();
  }

  getOrganizationInfo() {
    this.orgInformation = null;
    this.userService.getOrgProfile().subscribe((response) => {
      if (response.success) {
        this.orgInformation = response.data;
        this.orgInformation.locations = (this.orgInformation && this.orgInformation.locations) ?
          JSON.parse(this.orgInformation.locations) : [];
        const config = this.readConfigService.getPaymentMethodInfo().PaymentTypeLabel;
        if (config && this.orgInformation.paymentMethodId) {
          this.paymentType = config.find((s: any) => s.id === this.orgInformation.paymentMethodId).name;
        }
      }
      this.notificationService.setUpLoading(false);
    }, (error: HttpErrorResponse) => {
      console.log(error);
      this.notificationService.setUpLoading(false);
      this.notificationService.setErrorNotification();
    });
  }
}
